import { ReactNode, ReactElement } from 'react';

import { ButtonProps } from '@mui/material';

export enum NAV_TYPE {
  SINGLE = 'SINGLE',
  MULTIPLE = 'MULTIPLE',
  BUTTON = 'BUTTON',
  COMPONENT = 'COMPONENT',
}

export interface NavItemType {
  type?: NAV_TYPE;
  path?: string;
  text: string | ReactNode;
  buttonProps?: any;
  isActive?: boolean;
  isExternal?: boolean;
  onClick?: () => void;
  isNewTheme?: boolean;
  publicPath?: string;
  children?: ReactNode;
}

export interface NavItemSingle extends NavItemType {
  type?: NAV_TYPE.SINGLE;
}

export interface NavItemMultiple extends NavItemType {
  type: NAV_TYPE.MULTIPLE;
  subItems: NavItemProps[];
}

export interface NavItemButton extends NavItemType {
  type: NAV_TYPE.BUTTON;
  buttonProps?: ButtonProps;
}

export interface NavItemReactFC extends NavItemType {
  type: NAV_TYPE.COMPONENT;
  component?: ReactElement;
}

export type NavItemProps = NavItemSingle | NavItemButton | NavItemMultiple | NavItemReactFC;

export type NavItemComponent<T> = (item: NavItemProps, idx: number) => T;

export type ApplyFn = (item: NavItemProps) => NavItemProps;
